<template>
    <v-flex v-if="pillItem" class="filter-pill">
        <span class="filter-pill__close">
            <v-icon @click="close" color="black" size="18"
                    :data-qe-id="`member-directory_filer-pill_${filterIndex}_remove_btn`">close</v-icon></span>
        <span class="filter-pill__name" :data-qe-id="`member-directory_filer-pill_${filterIndex}_label`">{{pillLabel}}</span>
    </v-flex>
</template>
<script>
    import { pillWithType, memberDirectoryPageConstant } from "../memberDirectoryPage.constants";

    export default {
        name: 'FilterPill',
        props: {
            pillItem: {
                type: Object,
                required: true,
            },
            filterIndex: {
                type: Number,
                required: true,
            },
            handleClose: {
                type: Function,
                required: true,
            },
        },
        methods: {
            close() {
                this.handleClose(this.pillItem);
            },
        },
        computed: {
            pillLabel() {
                let pillType = null;
                if (this.pillItem) {
                    pillType = pillWithType.find(pill => pill.key === this.pillItem.filterKey);
                }
                if (this.pillItem.filterKey === memberDirectoryPageConstant.constant.combinedCountryStateKey) {
                    const dividerIndex = this.pillItem.filterValue.indexOf('>');
                    if (dividerIndex > 0) {
                        return `${this.pillItem.filterValue.substring(0, dividerIndex)}, ${this.pillItem.label}`;
                    }
                }
                return pillType ? `${pillType.label} ${this.pillItem.label}` : this.pillItem.label;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .filter-pill {
        border: 1px solid $ypo-tile-border;
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        border-radius: 16px;
        background-color: $white;
        flex: 0 1 auto !important;
        padding: 5px 10px;

        &__close {
            color: $black;
            position: relative;
            margin-top: -2px;
        }

        &__name {
            padding-left: 5px;
            color: $ypo-cta;
        }
    }

</style>
